export const REDUX_CHANGE = '@@redux-form/CHANGE';
export const REDUX_BLUR = '@@redux-form/BLUR';

export const VALIDATE_USER_TYPE = '@bandejaVivienda/validateUserType';
export const SAVED_INFO_USER_BANDEJA = '@bandejaVivienda/savedInfoUserBandeja';
export const SET_DATA_PAGINAR_REG_VIVIENDA = '@bandejaVivienda/setDataPaginarRegVivienda';
export const PAGINAR_DATA_REG_VIVIENDA = '@bandejaVivienda/paginarDataRegVivienda';
export const SEARCH_FORM_FROM_TABLE = '@bandejaVivienda/searchFormFromTable';
export const ERROR_GENERAL = '@bandejaVivienda/errorGeneral';
export const OPEN_SEE_FILES_UNIFIED = '@bandejaVivienda/openSeeFilesUnified';
export const DEVOLVER_POSTULATION_FROM_TABLE = '@bandejaVivienda/devolverPostulationFromTable';
export const ANULAR_POSTULATION_FROM_TABLE = '@bandejaVivienda/anularPostulationFromTable';
export const MESSAGE_ALERT_SEND = '@bandejaVivienda/messageAlertSend';
export const RETURN_HOME_BANDEJA = '@bandejaVivienda/returnHomeBandeja';
export const GESTIONA_MODAL_TRY_CATCH = '@bandejaVivienda/gestionAModalTryCatch';
export const EXPORT_DATA_FORM_XLSX = '@bandejaVivienda/exportDataFormXLSX';
export const SAVE_AUTHUSER_OF_SESSION = '@bandejaVivienda/saveAuthuserOfSession';

export const CLOSE_MODALES = '@bandejaVivienda/closeModales';
export const OPEN_FORM_BANDEJA = '@bandejaVivienda/openFormBandeja';

export const DATA_POR_VALIDAR = "No se encuentran solicitudes pendientes de validación para su usuario";
export const TITLE_TABLE_PAGINATOR_EMPRESAS = 'Actualización Postulaciones a subsidio de vivienda';

export const VISUALIZE_ANEXOS = '@bandejaVivienda/visualizeAnexos';
export const CLOSE_MODAL_ANEXOS = '@bandejaVivienda/closeModalAnexos';
export const OPEN_MODAL_CHARGED = '@bandejaVivienda/openModalCharged';
export const OCULTAR_DEVOLUCIONES = '@bandejaVivienda/ocultarDevoluciones';
export const OCULTAR_DE_ANULACIONES = '@bandejaVivienda/ocultarDeAnulaciones';
export const SEARCH_HISTORIAL_BANDEJA = '@bandejaVivienda/searchHistorialBandeja';
export const OPEN_HISTORIAL_BANDEJA = '@bandejaVivienda/openHistoryBandeja';
export const ACTIONS_OF_APROVE = '@bandejaVivienda/actionsButtonsAprove';
export const MESSAGE_CONFIRMATION_SEND = '@bandejaVivienda/messageConfirmationSend'
export const DEVOLUCIONES_FORM_NAME = 'devolucionForm';
export const ANULACION_FORM_NAME = 'anulacionForm';
export const ASIGNACION_FORM_NAME = 'anulacionForm';
export const LOAD_DOCUMENT_SUCCESS = '@bandejaVivienda/loadDocumentSuccess';
export const ANULACION_FORM_TITLE = 'Anulaciones';
export const ASIGNACION_FORM_TITLE = 'Asignaciones';
export const OPEN_ANULATION_FORM = '@bandejaVivienda/openAnulationForm';
export const TYPE_USER_BANDEJA_VIVIENDA = '@bandejaVivienda/typeUserBandejaVivienda';
export const OPEN_ANEXOS_FROM_TABLE = '@bandejaVivienda/openAnexosFromTable';
export const VISUALIZE_ANEXOS_FROM_TABLE = '@bandejaVivienda/visualizeAnexosFromTable';
export const OPEN_MODAL_ANULATION_TABLE = '@bandejaVivienda/openModalAnulationTable';
export const OPEN_MODAL_ASIGNA_ASESOR_TABLE = '@bandejaVivienda/openModalAsignaAsesorTable';
export const OPEN_MODAL_DEVOLUTION_TABLE = '@bandejaVivienda/openModalDevolutionTable';
export const SAVED_ACTIONS_VALIDATION = '@bandejaVivienda/savedActivations;';
export const SAVE_DATA_TABLE_ANULA_DEVOL = '@bandejaVivienda/saveDataTableAnulaDevol';
export const LOAD_CATALOG_BANDEJA = '@bandejaVivienda/loadCatalogBandeja';
export const INIT_FORM_FROM_REVALIDACION = '@bandejaVivienda/initFormFromRevalidacion';
export const INIT_BANDEJA_ADMINISTRADOR = '@bandejaVivienda/initBandejaAdministrador';
export const ASIGNA_ASESOR_FORM = '@bandejaVivienda/asignaAsesorForm';
export const COLLAPSED_COMPONENT_FILTER = '@bandejaVivienda/collapsedComponetFilter';
export const INIT_FILTER_TABLE_BANDEJA = '@bandejaVivienda/initFilterTableBandeja';
export const CLEAN_FILTER_FORM = '@bandejaVivienda/cleanFilterForm';

export const REPORTS_FORM_NAME = 'reportsForm';



export const HEADERS_WS = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    'Access-Control-Allow-Credentials': 'true',
    "Access-Control-Request-Headers": "access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,auth,authorization,cache-control,content-type,mode",
    'accept': "application/json, text/plain, */*",
    "Authorization": 'Basic Rk9STVVMQVJJT1NXRUI6WWsyMTkwX3c=',
    "content-type": "application/json",
    "Cache-Control": "no-cache",
    'mode': "opaque ",
}

export const MESSAGES_ALERT_PARAMETRIZADOS = [
    { value: "msgRegiDownloadNotBD", download: false, label: "La actualización que intenta descargar no se encontro en base de datos, por favor inténtelo nuevamente. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2" },
    { value: "msgNotPermitAccessUser", download: false, label: "El usuario no cuenta con los permisos necesarios para acceder a la informacion de la bandeja." },
    { value: "msgDevolCmrSuccess", download: false, label: "El proceso de devolución a comercial ha terminado exitosamente." },
    { value: "msgDevolCmrFailure", download: false, label: "No se pudo realizar el proceso de devolución a comercial correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
    { value: "msgAfiliaSuccess", download: false, label: "La actualización de la solicitud, se procesó exitosamente. Por favor realice las validaciones correspondientes" },
    { value: "msgAfiliaFailure", download: false, label: "No se pudo realizar el proceso de actualización correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
    { value: "msgDevolSuccess", download: false, label: "El proceso de devolución ha terminado exitosamente." },
    { value: "msgDevolFailure", download: false, label: "No se pudo realizar el proceso de devolucion correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
    { value: "msgAnulaSuccess", download: false, label: "El proceso de anulación ha terminado exitosamente." },
    { value: "msgAnulaFailure", download: false, label: "No se pudo realizar el proceso de anulación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente" },
    { value: "msgAprobacionSuccess", download: false, label: "El proceso de aprobación ha terminado exitosamente." },
    { value: "msgAprobacionFailure", download: false, label: "No se pudo realizar el proceso de aprobación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente" },
    { value: "msgAsignaSuccess", download: false, label: "El proceso de asiganción ha terminado exitosamente." },
]

export const HEADER_TABLE_PAGINATOR_VIVIENDA = [
    { field: "dateUpdate", header: "Fecha actualización", sortable: true },
    { field: "oportunidad", header: "N° Oportunidad", sortable: false },
    { field: "idUser", header: "Identificación", sortable: false },
    { field: "nameUser", header: "Nombres", sortable: false },
    { field: "cellPhone", header: "Teléfono", sortable: false },
    { field: "dateAsigna", header: "Fecha asignación", sortable: false },
    { field: "dateManage", header: "Fecha gestión", sortable: true },
    { field: "asesor", header: "Responsable", sortable: false },
    { field: "stateLabel", header: "Estado", sortable: false }
];

export const HEADER_TABLE_EXPORT_VIVIENDA = [
    { field: "dateUpdate", header: "Fecha actualización", sortable: true },
    { field: "oportunidad", header: "N° Oportunidad", sortable: true },
    { field: "idUser", header: "Identificación", sortable: true },
    { field: "nameUser", header: "Nombres", sortable: true },
    { field: "cellPhone", header: "Teléfono", sortable: true },
    { field: "dateAsigna", header: "Fecha asignación", sortable: true },
    { field: "dateManage", header: "Fecha gestión", sortable: true },
    { field: "asesor", header: "Responsable", sortable: true },
    { field: "stateLabel", header: "Estado", sortable: true }
];
export const CATALOG_STATES = [{ "label": "Validación", "value": "2" }, { "label": "Anulada", "value": "4" }, { "label": "Unificacion", "value": "1" }, { "label": "Actualizada", "value": "9" }, { "value": "5", "label": "Devuelta" }, { "label": "Borrador", "value": "0" }, { "value": "3", "label": "Re-validación" }]

export const DEVOLUCIONES_FORM = [

    {
        label: "",
        name: "datosdevolucion",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo de la anualación",
                label: "Motivo devolución",
                name: "motivoDevolucion",
                placeholder: "Motivo devolución",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [],
                disabled: false,
                className: "rs-40 modal-autocomplete"
            },
            {
                //tooltip: "Ingresa la observacion pertinente",
                label: "Observación",
                name: "observation",
                placeholder: "Observación",
                type: "text",
                typeForm: "text",
                maxLength: 500,
                value: false,
                options: [],
                disabled: false,
                className: "rs-60",
                hidden: false
            },

        ]
    }
]

export const ANULACION_FORM = [
    {
        label: ANULACION_FORM_TITLE,
        name: "datosanulacion",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo específico de la anualación",
                label: "Motivo anulación",
                name: "motivoAnulacion",
                placeholder: "Motivo anulación",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [],
                disabled: false,
                className: "rs-40 modal-autocomplete"
            },
            {
                //tooltip: "Ingresa la observacion pertinente",
                label: "Observación",
                name: "observationAnulation",
                placeholder: "Observación",
                type: "text",
                typeForm: "text",
                maxLength: 500,
                value: false,
                options: [],
                disabled: false,
                className: "rs-60",
                hidden: false
            },

        ]
    }
]

export const ASIGNACION_FORM = [
    {
        label: ASIGNACION_FORM_TITLE,
        name: "datosasignacion",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo específico de la anualación",
                label: "Seleccione un asesor",
                name: "asesorDisponible",
                placeholder: "Seleccione un asesor",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [],
                disabled: false,
                className: "rs-40"
            },
            {
                //tooltip: "Ingresa la observacion pertinente",
                label: "Email",
                name: "emailAsesor",
                placeholder: "Email",
                type: "text",
                typeForm: "text",
                maxLength: 2000,
                value: false,
                options: [],
                disabled: true,
                className: "rs-60",
                hidden: false
            },

        ]
    }
]

export const panelReportsForm = (handleFilterReport, cleanFilterForm) => {
    return [
        {
            label: "",
            name: "informesCompanys",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    tooltip: "Ingresa el año, mes y día en que inició obligaciones como Empleador (ver en RUT en la casilla 47).",
                    label: "Fecha inicial",
                    name: "dateStart",
                    placeholder: " ",
                    type: "date",
                    typeForm: "date",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-25"
                },
                {
                    tooltip: "Ingresa el año, mes y día en que inició obligaciones como Empleador (ver en RUT en la casilla 47).",
                    label: "Fecha final",
                    name: "dateEnd",
                    placeholder: " ",
                    type: "date",
                    typeForm: "date",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-25"
                },
                {
                    tooltip: "Selecciona uno de los dos tipos de fecha por los cuales se realizara la busqueda",
                    label: "Tipo fecha",
                    name: "dateType",
                    placeholder: "Tipo fecha*",
                    type: "select",
                    typeForm: "select",
                    value: false,
                    options: [{ label: "Fecha de actualización", value: "1" }, { label: "Fecha de asiganción", value: "2" }],
                    disabled: false,
                    className: "rs-20",
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "Resultados",
                    name: "numResultados",
                    placeholder: "",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: "10",
                    options: [],
                    disabled: true,
                    className: "rs-20 contador-filter",
                    hidden: false
                },
                {
                    //tooltip: "Seleccione el motivo específico de la anualación",
                    label: "Estado actualización",
                    name: "stateAfilia",
                    placeholder: "Estado actualización",
                    type: "MLTselect",
                    typeForm: "MLTselect",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30"
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "Identificación",
                    name: "idCompanyReport",
                    placeholder: "Identificación",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-20",
                    hidden: false
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "N° Oportunidad",
                    name: "idOportunidadReport",
                    placeholder: "N° Oportunidad",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-20",
                    hidden: false
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "Responsable",
                    name: "asesorResponsable",
                    placeholder: "Responsable",
                    type: "select",
                    typeForm: "select",
                    maxLength: 30,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-20",
                    hidden: false
                },
                {
                    name: "filterReport",
                    placeholder: "Filtrar",
                    type: "buttonX",
                    typeForm: "buttonX",
                    primary: true,
                    value: false,
                    options: [],
                    hidden: false,
                    disabled: false,
                    className: "rs-20",
                    onClick: handleFilterReport,
                },
                {
                    name: "filterReport",
                    placeholder: "Limpiar",
                    type: "buttonX",
                    typeForm: "buttonX",
                    primary: true,
                    value: false,
                    options: [],
                    hidden: false,
                    disabled: false,
                    className: "rs-20 cleanFilter",
                    onClick: cleanFilterForm,
                }

            ]
        }
    ]
}

export const panelReportsFormComercial = (handleFilterReport, cleanFilterForm) => {
    return [
        {
            label: "",
            name: "informesCompanys",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    tooltip: "Ingresa el año, mes y día en que inició obligaciones como Empleador (ver en RUT en la casilla 47).",
                    label: "Fecha inicial",
                    name: "dateStart",
                    placeholder: " ",
                    type: "date",
                    typeForm: "date",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-25"
                },
                {
                    tooltip: "Ingresa el año, mes y día en que inició obligaciones como Empleador (ver en RUT en la casilla 47).",
                    label: "Fecha final",
                    name: "dateEnd",
                    placeholder: " ",
                    type: "date",
                    typeForm: "date",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-25"
                },
                {
                    tooltip: "Selecciona uno de los dos tipos de fecha por los cuales se realizara la busqueda",
                    label: "Tipo fecha",
                    name: "dateType",
                    placeholder: "Tipo fecha*",
                    type: "select",
                    typeForm: "select",
                    value: false,
                    options: [{ label: "Fecha de actualización", value: "1" }, { label: "Fecha de asiganción", value: "2" }],
                    disabled: false,
                    className: "rs-20",
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "Resultados",
                    name: "numResultados",
                    placeholder: "",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: "10",
                    options: [],
                    disabled: true,
                    className: "rs-20 contador-filter",
                    hidden: false
                },
                {
                    //tooltip: "Seleccione el motivo específico de la anualación",
                    label: "Estado actualización",
                    name: "stateAfilia",
                    placeholder: "Estado actualización",
                    type: "MLTselect",
                    typeForm: "MLTselect",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30"
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "Identificación",
                    name: "idCompanyReport",
                    placeholder: "Identificación",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-20",
                    hidden: false
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "N° Oportunidad",
                    name: "idOportunidadReport",
                    placeholder: "N° Oportunidad",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-20",
                    hidden: false
                },
                // {
                //     //tooltip: "Ingresa la observacion pertinente",
                //     label: "Responsable",
                //     name: "asesorResponsable",
                //     placeholder: "Responsable",
                //     type: "select",
                //     typeForm: "select",
                //     maxLength: 30,
                //     value: false,
                //     options: [],
                //     disabled: false,
                //     className: "rs-20",
                //     hidden: false
                // },
                {
                    name: "filterReport",
                    placeholder: "Filtrar",
                    type: "buttonX",
                    typeForm: "buttonX",
                    primary: true,
                    value: false,
                    options: [],
                    hidden: false,
                    disabled: false,
                    className: "rs-20",
                    onClick: handleFilterReport,
                },
                {
                    name: "filterReport",
                    placeholder: "Limpiar",
                    type: "buttonX",
                    typeForm: "buttonX",
                    primary: true,
                    value: false,
                    options: [],
                    hidden: false,
                    disabled: false,
                    className: "rs-20 cleanFilter",
                    onClick: cleanFilterForm,
                }

            ]
        }
    ]
}

